import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { UserPermissions } from '../../services/permissions';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnDestroy {
  heroTitle = '';
  private langChangeSub: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private translateService: TranslateService
  ) {
    this.updateHeroTitle();
    this.langChangeSub = this.translateService.onLangChange.subscribe(() => this.updateHeroTitle());
  }

  ngOnDestroy(): void {
    this.langChangeSub.unsubscribe();
  }

  get isEnglish(): boolean {
    return this.translateService.currentLang === 'en';
  }

  get canAccessVision(): boolean {
    return this.authService.hasPermission(UserPermissions.ADMIN_DASHBOARD);
  }

  get canAccessReach(): boolean {
    return this.authService.hasPermission(UserPermissions.REACH_AUDIENCE);
  }

  navigateToVision(): void {
    this.router.navigate(['/vision/public']);
  }

  navigateToReach(): void {
    this.router.navigate(['/reach/audiences']);
  }

  private updateHeroTitle(): void {
    const raw = this.translateService.instant('home.heroTitle');
    const highlight = '<span class="hero-highlight">TNC Engine</span>';
    this.heroTitle = raw
      .replace(/<span class="hero-highlight">TNC Engine<\/span>/g, highlight)
      .replace(/TNC Engine/g, highlight);
  }
}
